import { render, staticRenderFns } from "./ChartsUI.vue?vue&type=template&id=954a47be"
import script from "./ChartsUI.vue?vue&type=script&lang=js"
export * from "./ChartsUI.vue?vue&type=script&lang=js"
import style0 from "./ChartsUI.vue?vue&type=style&index=0&id=954a47be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports